const Pager = ({
    backPage = 0,
    currentPage = 0,
    limit = 0,
    nextPage = 0,
    numPages = 0,
    start = 0,
    tenPageEnd = 0,
    tenPageStart = 0,
    total = 0,
} = {}) => ({
    backPage: Number(backPage),
    currentPage: Number(currentPage),
    limit: Number(limit),
    nextPage: Number(nextPage),
    numPages: Number(numPages),
    start: Number(start),
    tenPageEnd: Number(tenPageEnd),
    tenPageStart: Number(tenPageStart),
    total: Number(total),
});

export default Pager;
